import { render, staticRenderFns } from "./JSONEditor.vue?vue&type=template&id=cdf442ac&"
import script from "./JSONEditor.vue?vue&type=script&lang=js&"
export * from "./JSONEditor.vue?vue&type=script&lang=js&"
import style0 from "./JSONEditor.vue?vue&type=style&index=0&id=cdf442ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports